up.compiler('[cookie-consent]', function(fragment) {
  const consentButton = up.element.get(fragment, '.cookie-consent--actions button')

  up.on(consentButton, 'click', () => {
    document.cookie = 'cookies_accepted=1; Max-Age=31536000; Path=/'
    fragment.remove()
  })
})
